"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkedList = void 0;
const BasicEnumerable_1 = require("../enumerables/BasicEnumerable");
const EnumerableFactory_1 = require("../utilities/EnumerableFactory");
const LinkedListNode_1 = require("./LinkedListNode");
const utilityFunctions_1 = require("../utilities/utilityFunctions");
class LinkedList extends BasicEnumerable_1.BasicEnumerable {
    constructor(collection) {
        super(new EnumerableFactory_1.EnumerableFactory(), (0, utilityFunctions_1.getIterableGenerator)([]));
        this.firstNode = null;
        this.lastNode = null;
        this.listLength = 0;
        this.srcGenerator = this.generator;
        for (const item of collection !== null && collection !== void 0 ? collection : []) {
            this.addLast(item);
        }
    }
    get firstListNode() {
        return this.firstNode;
    }
    get lastListNode() {
        return this.lastNode;
    }
    get length() {
        return this.listLength;
    }
    addAfter(node, newNodeOrItem) {
        if (node.list !== this) {
            throw new Error('Node must belong to the list.');
        }
        let newNode;
        if (newNodeOrItem instanceof LinkedListNode_1.LinkedListNode) {
            if (newNodeOrItem.list !== null) {
                throw new Error('newNode cannot belong to a list.');
            }
            newNode = newNodeOrItem;
        }
        else {
            newNode = new LinkedListNode_1.LinkedListNode(newNodeOrItem);
        }
        newNode.list = this;
        newNode.previous = node;
        newNode.next = node.next;
        if (node.next) {
            node.next.previous = newNode;
        }
        node.next = newNode;
        this.listLength++;
        return newNode;
    }
    addBefore(node, newNodeOrItem) {
        if (node.list !== this) {
            throw new Error('Node must belong to the list.');
        }
        let newNode;
        if (newNodeOrItem instanceof LinkedListNode_1.LinkedListNode) {
            if (newNodeOrItem.list !== null) {
                throw new Error('newNode cannot belong to a list.');
            }
            newNode = newNodeOrItem;
        }
        else {
            newNode = new LinkedListNode_1.LinkedListNode(newNodeOrItem);
        }
        newNode.list = this;
        newNode.previous = node.previous;
        newNode.next = node;
        if (node.previous) {
            node.previous.next = newNode;
        }
        node.previous = newNode;
        this.listLength++;
        return newNode;
    }
    addFirst(newNodeOrItem) {
        let newNode;
        if (newNodeOrItem instanceof LinkedListNode_1.LinkedListNode) {
            if (newNodeOrItem.list !== null) {
                throw new Error('newNode cannot belong to a list.');
            }
            newNode = newNodeOrItem;
        }
        else {
            newNode = new LinkedListNode_1.LinkedListNode(newNodeOrItem);
        }
        newNode.list = this;
        if (!this.firstNode) {
            this.firstNode = newNode;
        }
        else {
            newNode.next = this.firstNode;
            this.firstNode.previous = newNode;
            this.firstNode = newNode;
        }
        if (!this.lastNode) {
            this.lastNode = newNode;
        }
        this.listLength++;
        return newNode;
    }
    addLast(newNodeOrItem) {
        let newNode;
        if (newNodeOrItem instanceof LinkedListNode_1.LinkedListNode) {
            if (newNodeOrItem.list !== null) {
                throw new Error('newNode cannot belong to a list.');
            }
            newNode = newNodeOrItem;
        }
        else {
            newNode = new LinkedListNode_1.LinkedListNode(newNodeOrItem);
        }
        newNode.list = this;
        if (!this.firstNode) {
            this.firstNode = newNode;
        }
        if (!this.lastNode) {
            this.lastNode = newNode;
        }
        else {
            newNode.previous = this.lastNode;
            this.lastNode.next = newNode;
            this.lastNode = newNode;
        }
        this.listLength++;
        return newNode;
    }
    clear() {
        let node = this.firstNode;
        while (node) {
            const next = node.next;
            node.previous = null;
            node.next = null;
            node = next;
        }
        this.firstNode = null;
        this.lastNode = null;
        this.listLength = 0;
    }
    copyTo(array, arrayIndex) {
        let i = arrayIndex;
        for (const item of this) {
            array[i] = item;
            i++;
        }
    }
    remove(newNodeOrItem) {
        if (newNodeOrItem instanceof LinkedListNode_1.LinkedListNode && newNodeOrItem.list !== this) {
            return false;
        }
        let node = this.firstNode;
        while (node) {
            if (node === newNodeOrItem || node.value === newNodeOrItem) {
                if (node.previous) {
                    node.previous.next = node.next;
                }
                if (node.next) {
                    node.next.previous = node.previous;
                }
                node.next = null;
                node.previous = null;
                this.listLength--;
                return true;
            }
            node = node.next;
        }
        return false;
    }
    removeFirst() {
        if (this.listLength === 1 || !this.firstNode) {
            this.clear();
            return;
        }
        const first = this.firstNode;
        this.firstNode = this.firstNode.next;
        if (this.firstNode) {
            this.firstNode.previous = null;
        }
        first.next = null;
        first.previous = null;
        this.listLength--;
    }
    removeLast() {
        if (this.listLength === 1 || !this.lastNode) {
            this.clear();
            return;
        }
        const last = this.lastNode;
        this.lastNode = this.lastNode.previous;
        if (this.lastNode) {
            this.lastNode.next = null;
        }
        last.next = null;
        last.previous = null;
        this.listLength--;
    }
    *generator() {
        let node = this.firstNode;
        while (node) {
            yield node.value;
            node = node.next;
        }
    }
}
exports.LinkedList = LinkedList;
//# sourceMappingURL=LinkedList.js.map